import { SchemaColumnOptions, SchemaTableOptions } from "@/vendors/prx-sqlite/Interfaces/SchemaInterfaces";

export const indigeneous_peoples:SchemaTableOptions = {
    name:<string> 'indigeneous_peoples',
    schema:<Array<SchemaColumnOptions>> [
        { column: 'id', value: 'INTEGER PRIMARY KEY AUTOINCREMENT'},
        { column: 'name', value: 'VARCHAR(255) NOT NULL'},
    ]
}